import classNames from "classnames";
import styles from "./style.module.scss";

const Wrapper = ({ children }: any) => {
  return <div className={classNames(styles.bg)}>{children}</div>;
};

export default Wrapper;
